import React, { createContext, useContext, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  signInWithPopup,
  GoogleAuthProvider,
  updatePassword,
  updateEmail,
  sendPasswordResetEmail,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from 'firebase/auth';
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  doc,
  deleteDoc,
  setDoc,
} from 'firebase/firestore';
import { db } from '../firebase';


// import {app, auth} from '../firebase' - could delete if not broken
import { auth } from '../firebase';
import { FirebaseError } from 'firebase/app';



const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}
//have accesss to auth context through useAuth hook

// GOOGLE SIGN INPOP UP
const provider = new GoogleAuthProvider();

//AUTH METHODS
export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const signInWithGooglePopUp = () => {
    signInWithPopup(auth, provider)
      .then((result) => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        // The signed-in user info.
        const user = result.user;
        const newUser = doc(db, `user-goals/${result.user.uid}`);
        const data = {
          email: result.user.email,
          streakCounter: 0,
        };
        setDoc(newUser, data);
        navigate('/');
      })
      .catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const email = error.customData.email;
        // The AuthCredential type that was used.
        const credential = GoogleAuthProvider.credentialFromError(error);
        // ...
      });
  };

  function signup(email, password) {
    return createUserWithEmailAndPassword(auth, email, password).then(
      (cred) => {
        const data = {
          email: email,
          streakCounter: 0,
        };
        // const res = await db.collection('user-goals').doc(cred.user.uid).set(data)
        const newUser = doc(db, `user-goals/${cred.user.uid}`);
        setDoc(newUser, data);
      }
    );
  }
  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  function logout() {
    return signOut(auth);
  }

  function resetPassword(email) {
    return sendPasswordResetEmail(auth, email);
  }

  function updateUserEmail(email) {
    return updateEmail(auth.currentUser, email);
  }

  function updateUserPassword(password) {
    return updatePassword(auth.currentUser, password);
  }

  

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    signup,
    login,
    logout,
    resetPassword,
    updateUserEmail,
    updateUserPassword,
    signInWithGooglePopUp,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
//access user info anytime in application
